module.exports = __webpack_public_path__ + "assets/img/13.5b3b5ca1.png";